import { createBrowserRouter, Navigate } from 'react-router-dom'
import { RouteErrorBoundary } from '@/app/routes/route-error-boundary'

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <RouteErrorBoundary />,
    lazy: () => import('@/app/layouts/root-layout').then((m) => ({ Component: m.RootLayout })),
    children: [
      {
        index: true,
        lazy: () =>
          import('@/modules/home/screens/landing').then((m) => ({ Component: m.LandingScreen })),
      },
      {
        path: 'privacidade',
        lazy: () =>
          import('@/modules/home/screens/privacy-policy').then((m) => ({
            Component: m.PrivacyPolicyScreen,
          })),
      },
      {
        path: 'catalogo',
        lazy: () =>
          import('@/modules/home/screens/catalog').then((m) => ({
            Component: m.CatalogScreen,
          })),
      },
      {
        path: 'p/:token',
        lazy: () =>
          import('@/modules/client-access/screens/client-gate').then((m) => ({
            Component: m.ClientGateScreen,
          })),
      },
      {
        path: 'p/:token/view',
        lazy: () =>
          import('@/modules/client-access/screens/property-showcase').then((m) => ({
            Component: m.PropertyShowcaseScreen,
          })),
      },
      {
        path: 'imovel/:token',
        lazy: () =>
          import('@/modules/client-access/screens/property-showcase').then((m) => ({
            Component: m.PropertyShowcaseScreen,
          })),
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
])
